import styled from "styled-components";
import {
  PRIMARY_BLUE,
  PRIMARY_DARK_BLUE,
  SECONDARY_RED,
} from "../../constants/color";

type BadgeVariant = "success" | "error" | "processing";

type Props = {
  text: string;
  variant: BadgeVariant;
};

export const Badge: React.FC<Props> = ({ text, variant }) => {
  return (
    <StyledBadgeContainer $variant={variant}>
      <StyledText>{text}</StyledText>
    </StyledBadgeContainer>
  );
};

const StyledBadgeContainer = styled.div<{ $variant: BadgeVariant }>`
  height: 22px;
  display: flex;
  padding: 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 20px;
  background: ${({ $variant }) => {
    if ($variant === "success") return PRIMARY_BLUE;
    if ($variant === "error") return SECONDARY_RED;
    return PRIMARY_DARK_BLUE;
  }};
`;

const StyledText = styled.div`
  color: #ffffff;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
`;
